import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Dipesh Goyal",
      role: "Director",
      company: "Covalent Connections",
      img: "/assets/img/person/Dipesh.jpeg",
      text:
        "The Autobotics team blends creativity with technology perfectly. From web design to intelligent process automation, their solutions just work — efficiently and beautifully.",
      delay: 100,
    },
    {
      name: "Vishva Manavadariya",
      role: "President",
      company: "Narayani Trust",
      img: "/assets/img/person/Vishwa.jpeg",
      text:
        "Our website redesign by Autobotics changed the way our customers see us. It’s faster, cleaner, and feels like a brand built for today.",
      delay: 200,
    },
    {
      name: "Dr. Pooja Kantariya",
      role: "Grantor",
      company: "Abhyasika Mandal",
      img: "/assets/img/person/Pooja.jpeg",
      text:
        "Autobotics doesn’t just build systems — they build confidence. The automation they implemented saved us time, reduced errors, and helped our team focus on real priorities.",
      delay: 300,
    },
    {
      name: "Bhaumik Patel",
      role: "Founder",
      company: "The Aromaverse",
      img: "/assets/img/person/Bhaumik.jpeg",
      text:
        "Partnering with Autobotics completely changed how we operate. Their automation expertise cut down manual work by over 90%, and the AI agent integration made our workflows smarter than ever.",
      delay: 100,
    },
    {
      name: "Mr. Yash Doshi",
      role: "Founder",
      company: "A and sons trading",
      img: "/assets/img/person/Yash.jpeg",
      text:
        "Autobotics has streamlined our trading operations. Tasks that took hours now take minutes, with reliable accuracy and great support throughout.",
      delay: 100,
    },
  ];

  // useEffect(() => {
  //   AOS.init({ duration: 1000, once: true });

  //   const swiper = new Swiper(".testimonials-slider", {
  //     loop: true,
  //     speed: 600,
  //     autoplay: { delay: 4000 },
  //     centeredSlides: true,
  //     spaceBetween: 30,
  //     slidesPerView: 1,
  //     pagination: {
  //       el: ".swiper-pagination",
  //       type: "bullets",
  //       clickable: true,
  //     },
  //     breakpoints: {
  //       768: { slidesPerView: 1.5, spaceBetween: 30 },
  //       // 992: { slidesPerView: 2, spaceBetween: 30 },
  //       1200: { slidesPerView: 3, spaceBetween: 40 },
  //     },
  //   });

  //   return () => swiper.destroy();
  // }, []);

  return (
    <section id="testimonials" className="testimonials section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Testimonials</h2>
        <p>Our clients don’t just get projects delivered — they experience transformation. Here’s what leading brands say about working with Autobotics</p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="testimonials-slider swiper">
          <div className="swiper-wrapper">
            {testimonials.map((t, i) => (
              <div className="swiper-slide" key={i}>
                <div className="testimonial-card" data-aos="zoom-in" data-aos-delay={t.delay}>
                  {/* Header */}
                  <div className="testimonial-header">
                    <div className="user-avatar">
                      <img src={process.env.PUBLIC_URL + t.img} alt={t.name} />
                    </div>
                    <div className="user-info">
                      <h3>{t.name}</h3>
                      <span className="user-role">{t.role}</span>
                      <div className="rating">
                        {[...Array(5)].map((_, idx) => (
                          <i key={idx} className="bi bi-star-fill"></i>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="testimonial-content">
                    <div className="quote-mark">
                      <i className="bi bi-quote"></i>
                    </div>
                    <p>{t.text}</p>
                  </div>

                  {/* Footer */}
                  <div className="testimonial-footer">
                    <div className="company-badge">
                      <i className="bi bi-building"></i>
                      <span>{t.company}</span>
                    </div>
                    <div className="verified-badge">
                      <i className="bi bi-patch-check-fill"></i>
                      <span>Verified</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="swiper-pagination"></div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
